import React from 'react';

import { Link } from 'react-router';

export default class Shortcut extends React.Component {
  render() {
    const { checks } = this.props;
    return (
      <div id="shortcut">
        <ul>
          {checks &&
            (checks.isSuperAdmin ||
            checks.isSupervisingPhysician ||
            checks.isAdministrativeProvider) && (
              <li>
                <Link
                  to="/clinic-activity/chart-review"
                  title="Inbox"
                  className="jarvismetro-tile big-cubes bg-color-blue"
                >
                  <span className="iconbox">
                    {' '}
                    <i className="fa fa-hospital-o fa-4x" />{' '}
                    <span>Chart Review </span>{' '}
                  </span>
                </Link>
              </li>
            )}
          <li>
            <Link
              to="/profile"
              className="jarvismetro-tile big-cubes selected bg-color-pinkDark"
            >
              {' '}
              <span className="iconbox">
                {' '}
                <i className="fa fa-user fa-4x" /> <span>My Profile </span>{' '}
              </span>{' '}
            </Link>
          </li>
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/navigation/components/Shortcut.js